import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  pageLoading: false,
  purchaseOrderLoading: false,
  purchaseOrders: [],
  purchaseOrdersPagination: {},
});

export default function purchaseOrdersReducers(state = initialState, action) {
  switch (action.type) {
    // PurchaseOrders sorting
    case ACTIONS.SORT_PURCHASE_ORDERS.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.SORT_PURCHASE_ORDERS.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("purchaseOrders", action.data.data)
        .set("purchaseOrdersPagination", action.data.pagination);
    }
    case ACTIONS.SORT_PURCHASE_ORDERS.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // PurchaseOrders lisitng
    case ACTIONS.PURCHASE_ORDERS.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.PURCHASE_ORDERS.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("purchaseOrders", action.data.data)
        .set("purchaseOrdersPagination", action.data.pagination);
    }
    case ACTIONS.PURCHASE_ORDERS.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Create PurchaseOrders
    case ACTIONS.CREATE_PURCHASE_ORDER.PENDING: {
      return state.set("purchaseOrderLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_PURCHASE_ORDER.SUCCESS: {
      return state
        .set("purchaseOrderLoading", false)
        .set("error", "")
        .set("purchaseOrders", action.data.data)
        .set("purchaseOrdersPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_PURCHASE_ORDER.ERROR: {
      return state
        .set("error", action.error)
        .set("purchaseOrderLoading", false);
    }

    // Update PurchaseOrders
    case ACTIONS.UPDATE_PURCHASE_ORDER.PENDING: {
      return state.set("purchaseOrderLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_PURCHASE_ORDER.SUCCESS: {
      return state
        .set("purchaseOrderLoading", false)
        .set("error", "")
        .set("purchaseOrders", action.data.data)
        .set("purchaseOrdersPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_PURCHASE_ORDER.ERROR: {
      return state
        .set("error", action.error)
        .set("purchaseOrderLoading", false);
    }

    // Delete PurchaseOrders
    case ACTIONS.DELETE_PURCHASE_ORDER.PENDING: {
      return state.set("error", "").set("purchaseOrderLoading", true);
    }
    case ACTIONS.DELETE_PURCHASE_ORDER.SUCCESS: {
      return state
        .set("error", "")
        .set("purchaseOrderLoading", false)
        .set("purchaseOrders", action.data.data)
        .set("purchaseOrdersPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_PURCHASE_ORDER.ERROR: {
      return state
        .set("error", action.error)
        .set("purchaseOrderLoading", false);
    }

    default: {
      return state;
    }
  }
}
